"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayRule = (options) => {
    if (!options.stringArray) {
        options = Object.assign(Object.assign({}, options), { rotateStringArray: false, shuffleStringArray: false, stringArray: false, stringArrayEncoding: false, stringArrayThreshold: 0 });
    }
    return options;
};
